/**
 * Analytics helper: envuelve Plausible Custom Events de forma segura.
 * Si el script no está cargado (entorno sin NEXT_PUBLIC_PLAUSIBLE_DOMAIN o
 * adblockers), todos los métodos son no-op.
 *
 * Eventos del embudo:
 *   - "Register Submitted"      → al pulsar el botón de registro
 *   - "Register Completed"      → al crear cuenta exitosamente
 *   - "Lead Submitted"          → formulario de la landing
 *   - "Newsletter Subscribed"   → suscripción al newsletter
 *   - "Lesson Completed"        → marcar lección como completada
 *   - "Quiz Passed"             → aprobar el quiz de un módulo
 *   - "Quiz Failed"             → suspender el quiz de un módulo
 *   - "Final Exam Passed"       → aprobar el examen final
 *   - "Final Exam Failed"       → suspender el examen final
 *   - "Certificate Issued"      → emisión exitosa del certificado
 *   - "Certificate Downloaded"  → descarga del PDF del certificado
 *   - "Install App Clicked"     → click en el botón de instalar PWA
 */

type Props = Record<string, string | number | boolean | null | undefined>;

interface PlausibleWindow extends Window {
  plausible?: ((event: string, opts?: { props?: Props }) => void) & {
    q?: unknown[];
  };
}

export function trackEvent(event: string, props?: Props): void {
  if (typeof window === 'undefined') return;
  const w = window as PlausibleWindow;
  try {
    if (typeof w.plausible === 'function') {
      w.plausible(event, props ? { props } : undefined);
    }
  } catch {
    // silencioso: nunca rompamos el flujo por analytics
  }
}
